
// When the user clicks an error message anchor link 
// the page scrolls down to 30px above the target element (to show the label)
export function formErrorLinks() {

    var errorAnchors = [].slice.call(document.querySelectorAll(".error-anchor-link"));
    
    if (errorAnchors) {
        errorAnchors.forEach(errorAnchor => {
            errorAnchor.addEventListener("click", function (e) {
                e.preventDefault();

                var targetId = this.getAttribute("href");
                var targetElement = document.querySelector(targetId);
                var offset = 55;
                var bodyRect = document.body.getBoundingClientRect().top;
                var elementRect = targetElement.getBoundingClientRect().top;
                var elementPosition = elementRect - bodyRect;
                var offsetPosition = elementPosition - offset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            });
        });
    }
}
